// Reads the text of the contenteditable element when the user sends the message. A copy into a form field on a timer could
// miss the last keys that the user typed.

// The user can type on while the server writes the message. Only the sent text leaves the input: what follows it stays.
// If the user changed the sent text itself, the input stays as it is, so nothing typed is lost.
export function textLeftAfterSending(current, sent) {
  return current.startsWith(sent) ? current.slice(sent.length).replace(/^\n+/, "") : current;
}

const hook = {
  mounted() {
    this.editable = this.el.querySelector("[contenteditable]");

    this.el.addEventListener("submit", (event) => {
      event.preventDefault();
      this.send();
    });

    this.el.addEventListener("keydown", (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
        event.preventDefault();
        this.send();
      }
    });

    this.editable.addEventListener("input", () => this.showPlaceholder());
    this.showPlaceholder();

    this.handleEvent("pchat-prefill", ({ message }) => this.prefill(message));
    this.handleEvent("pchat-focus", () => this.editable.focus());
  },

  // Sends one message at a time. Clears the input only after the server accepts the message. If the server refuses the
  // message, or if the message is lost, the text stays in the input.
  send() {
    if (this.sending) return;
    this.sending = true;

    const message = this.editable.innerText;

    this.pushEvent("send", { message })
      .then(({ sent }) => {
        if (!sent) return;
        const current = this.editable.innerText;
        const left = textLeftAfterSending(current, message);
        if (left !== current) this.prefill(left);
      })
      .catch(() => {})
      .finally(() => (this.sending = false));
  },

  prefill(message) {
    this.editable.textContent = message;
    this.showPlaceholder();
    this.editable.focus();
    window.getSelection().selectAllChildren(this.editable);
    window.getSelection().collapseToEnd();
  },

  // Shows the placeholder when the text has only spaces. The server trims the text, so such a message is empty.
  showPlaceholder() {
    const content = this.editable.textContent.trim() === "" ? `"${this.editable.dataset.placeholder}"` : '""';
    this.editable.style.setProperty("--placeholder-content", content);
  },
};

export default hook;
